import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const InspectionTemplateTranslationKeys = {
  errorNoTemplates: translationKey('error_template_no_templates'),
  errorNoTemplatesHelperText: translationKey('error_template_no_templates_helper_text'),
  errorNotFound: translationKey('error_template_not_found'),
  errorNotFoundHelperText: translationKey('error_template_not_found_helper_text'),
  actionCreateSimilar: translationKey('inspection_template_action_create_similar'),
  actionEdit: translationKey('inspection_template_action_edit'),
  actionRemove: translationKey('inspection_template_action_remove'),
  actionStartInspection: translationKey('inspection_template_action_start_inspection'),
  appliedStandard: translationKey('inspection_template_applied_standard'),
  editDisabledReason: translationKey('inspection_template_edit_disabled_reason'),
  editOnArchivedWarning: translationKey('inspection_template_edit_on_archived_warning'),
  fieldLabelAuthor: translationKey('inspection_template_field_label_author'),
  fieldLabelCreationDate: translationKey('inspection_template_field_label_creation_date'),
  fieldLabelStandardDescription: translationKey('inspection_template_field_label_standard_description'),
  fieldLabelStatus: translationKey('inspection_template_field_label_status'),
  headerChecklist: translationKey('inspection_template_header_checklist'),
  headerChecklistCollapseAll: translationKey('inspection_template_header_checklist_collapse_all'),
  headerChecklistExpandAll: translationKey('inspection_template_header_checklist_expand_all'),
  headerGeneralAppliedStandard: translationKey('inspection_template_header_general_applied_standard'),
  previewGeneralStandards: translationKey('inspection_template_preview_general_standards'),
  previewNoEditPermissionInfoCopy: translationKey('inspection_template_preview_noEdit_permission_info_copy'),
  publishRequiresChecklistItem: translationKey('inspection_template_publish_requires_checklist_item'),
  statusDraft: translationKey('inspection_template_status_draft'),
  statusPublished: translationKey('inspection_template_status_published'),
  wizardAddItem: translationKey('inspection_template_wizard_add_item'),
  wizardAddNext: translationKey('inspection_template_wizard_add_next'),
  wizardAddSection: translationKey('inspection_template_wizard_add_section'),
  wizardAddSubsection: translationKey('inspection_template_wizard_add_subsection'),
  wizardBasicInfo: translationKey('inspection_template_wizard_basic_info'),
  wizardBasicInfoDescription: translationKey('inspection_template_wizard_basic_info_description'),
  wizardChecklist: translationKey('inspection_template_wizard_checklist'),
  wizardChecklistDescription: translationKey('inspection_template_wizard_checklist_description'),
  wizardChecklistItemAddNextDisabledReason: translationKey('inspection_template_wizard_checklist_item_add_next_disabled_reason'),
  wizardChecklistItemTitle: translationKey('inspection_template_wizard_checklist_item_title'),
  wizardCreateTemplate: translationKey('inspection_template_wizard_create_template'),
  wizardEditTemplate: translationKey('inspection_template_wizard_edit_template'),
  wizardEmptyChecklist: translationKey('inspection_template_wizard_empty_checklist'),
  wizardGeneralAppliedStandards: translationKey('inspection_template_wizard_general_applied_standards'),
  wizardGeneralAppliedStandardsDescription: translationKey('inspection_template_wizard_general_applied_standards_description'),
  wizardGeneralNormShowInspectionResult: translationKey('inspection_template_wizard_general_norm_show_inspection_result'),
  wizardItemPlaceholder: translationKey('inspection_template_wizard_item_placeholder'),
  wizardItemsCount: translationKey('inspection_template_wizard_items_count'),
  wizardSectionDefaultTitle: translationKey('inspection_template_wizard_section_default_title'),
  wizardSectionDescription: translationKey('inspection_template_wizard_section_description'),
  wizardSectionItems: translationKey('inspection_template_wizard_section_items'),
  wizardSectionPlaceholder: translationKey('inspection_template_wizard_section_placeholder'),
  wizardSectionTitle: translationKey('inspection_template_wizard_section_title'),
  wizardSectionsCount: translationKey('inspection_template_wizard_sections_count'),
  wizardSpecifiedAppliedStandardDescription: translationKey('inspection_template_wizard_specified_applied_standard_description'),
  wizardStandardDescription: translationKey('inspection_template_wizard_standard_description'),
  wizardSummary: translationKey('inspection_template_wizard_summary'),
  wizardVisibleFields: translationKey('inspection_template_wizard_visible_fields'),
  hideList: translationKey('inspection_templates_hide_list'),
  listSelectPrompt: translationKey('inspection_templates_list_select_prompt'),
  showList: translationKey('inspection_templates_show_list'),
  stateActiveTooltip: translationKey('template_state_active_tooltip'),
  stateArchivedTooltip: translationKey('template_state_archived_tooltip'),
} as const satisfies Record<string, TranslationKey>;
